import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import {
  getInitialLoadIcons,
  ZeeFontBold,
  ZeeFontRegular
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';
const animationSequence = css`
  @keyframes slide1 {
    0% {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
    30% {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
    40% {
      opacity: 0;
      transform: translateX(0) scale(2);
    }
    100% {
      opacity: 0;
      transform: translateX(0) scale(1);
    }
  }
  @keyframes slide2 {
    0% {
      opacity: 0;
      transform: translateX(0) scale(1);
    }
    29% {
      opacity: 0;
    }
    30% {
      opacity: 0;
    }
    70% {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
    80% {
      opacity: 0;
      transform: translateX(100%) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateX(100%) scale(1);
    }
  }
  @keyframes slide3 {
    0% {
      opacity: 0;
      transform: translateX(-100%) scale(1);
    }
    30% {
      opacity: 0;
      transform: translateX(-100%) scale(1);
    }
    70% {
      opacity: 0;
      transform: translateX(-100%) scale(1);
    }
    80% {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
    100% {
      opacity: 1;
      transform: translateX(0%);
    }
  }
  @keyframes animate-border {
    0% {
      border: 1px solid rgba(130, 48, 198, 1);
    }

    30% {
      border: 1px solid rgba(130, 48, 198, 1);
    }

    33% {
      border: 1px dashed white;
    }

    100% {
      border: 1px dashed white;
    }
  }
`;

const width = 122;
const height = 32;

export const Container = styled.div`
  ${animationSequence};
  display: flex;
  color: white;
  border: 1px ${colors.PurpleBtn};
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  width: ${width}px;
  height: ${height}px;
`;

export const slide1 = css`
  ${flex()};
  width: ${width}px;
  height: ${height}px;
  gap: 8px;
  position: absolute;
  background: ${colors.PurpleBtn};
  ${getInitialLoadIcons(InitialLoadIconsSet.CROWN)};
  ${ZeeFontBold(12, 18)};
  &:before {
    font-size: 14px;
  }
`;

export const slide2 = css`
  ${flex('row', 'center', 'flex-end')};
  gap: 10px;
  width: ${width}px;
  height: ${height}px;
  position: absolute;
  animation: 3s slide2 ease infinite alternate;
  ${ZeeFontBold(24, 32)};
  &: last-child {
    ${ZeeFontBold(14, 20)};
  }
`;
export const slide3 = css`
  ${flex()};
  width: ${width}px;
  height: ${height}px;
  position: absolute;
  animation: 3s slide3 ease infinite alternate;
`;
export const offerDiv = css`
  ${flex('row', 'space-evenly')};
  width: 100%;
  & > div {
    ${flex('column')};
    &: first-child {
      ${ZeeFontRegular(8, 11)};
      color: #c5c5c5;
    }
    &: last-child {
      ${ZeeFontBold(10, 13.5)};
      color: #c5c5c5;
    }
  }
`;

export const animatedBorder = css`
  animation: 3s animate-border ease infinite alternate;
`;

export const animatedSlide1 = css`
  animation: 3s slide1 ease infinite alternate;
`;
